// SidebarTableSelector.jsx
function SidebarTableSelector({ tables, selectedTables, onChange }) {
  return (
    <div className="list-group">
      {tables.map(table => (
        <label className="list-group-item" key={table}>
          <input
            type="checkbox"
            checked={selectedTables.includes(table)}
            onChange={() => onChange(table)}
          />{" "}
          {table}
        </label>
      ))}
    </div>
  );
}
export default SidebarTableSelector